export default [
  {
    question: "Quanto spesso usi la maschera?",
    answer1: "Sempre",
    answer2: "Quasi sempre",
    answer3: "Frequentemente",
    answer4: "Qualche volta",
    answer5: "Quasi mai",
    answer6: "Mai",
    img: "/images/survey/mascarilla.svg",
    advice:
      "Indossare la mascherina tutte le volte che si è vicino ad altre persone.",
    inverted: true,
  },
  {
    question: "Quanto spesso ti lavi le mani?",
    answer1: "Sempre",
    answer2: "Quasi sempre",
    answer3: "Frequentemente",
    answer4: "Qualche volta",
    answer5: "Quasi mai",
    answer6: "Mai",
    img: "/images/survey/lavado-manos.svg",
    advice: "Lavarsi le mani frequentemente.",
    inverted: true,
  },
  {
    question: "Quante ore alla settimana stai fuori casa in spazi aperti?",
    answer1: "Più di 50",
    answer2: "40 a 50",
    answer3: "30 a 40",
    answer4: "20 a 30",
    answer5: "10 a 20",
    answer6: "0 a 10",
    img: "/images/survey/espacios-abiertos.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "Quante ore alla settimana rimani fuori casa in spazi chiusi?",
    answer1: "Più di 50",
    answer2: "40 a 50",
    answer3: "30 a 40",
    answer4: "20 a 30",
    answer5: "10 a 20",
    answer6: "0 a 10",
    img: "/images/survey/espacios-cerrados.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "Quanto spesso ti tocchi il viso?",
    answer1: "Sempre",
    answer2: "Quasi sempre",
    answer3: "Frequentemente",
    answer4: "Qualche volta",
    answer5: "Quasi mai",
    answer6: "Mai",
    img: "/images/survey/tocar-cara.svg",
    advice: "Essere consapevoli e non toccarsi il viso.",
    inverted: false,
  },
  {
    question: "Quante persone vivono nella tua casa, a parte te?",
    answer1: "5 o più",
    answer2: "4",
    answer3: "3",
    answer4: "2",
    answer5: "1",
    answer6: "0",
    img: "/images/survey/habitantes-casa.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "Mantieni la distanza sociale consigliata con il resto delle persone?",
    answer1: "Sempre",
    answer2: "Quasi sempre",
    answer3: "Frequentemente",
    answer4: "Qualche volta",
    answer5: "Quasi mai",
    answer6: "Mai",
    img: "/images/survey/distanciamiento.svg",
    advice: "Mantenersi alla distanza consigliata rispetto ad altre persone.",
    inverted: true,
  },
  {
    question: "Usi contanti?",
    answer1: "Sempre",
    answer2: "Quasi sempre",
    answer3: "Frequentemente",
    answer4: "Qualche volta",
    answer5: "Quasi mai",
    answer6: "Mai",
    img: "/images/survey/dinero.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "Quanti minuti alla settimana usi l'ascensore della comunità?",
    answer1: "Mai",
    answer2: "0 a 2",
    answer3: "2 a 5",
    answer4: "5 a 10",
    answer5: "10 a 20",
    answer6: "Più di 20",
    img: "/images/survey/ascensor.svg",
    advice:
      "Usare le scale ogni volta che è possibile: si fa anche un po' di esercizio fisico.",
    inverted: true,
  },
  {
    question: "Quante ore alla settimana usi i mezzi pubblici?",
    answer1: "Più di 25",
    answer2: "20 a 25",
    answer3: "15 a 20",
    answer4: "10 a 15",
    answer5: "5 a 10",
    answer6: "0 a 5",
    img: "/images/survey/transporte-publico.svg",
    advice: "",
    inverted: false,
  },
];
